// upload.js
import restRequest from '../utils/restRequest'; // 导入封装好的 restRequest 工具

const API_BASE = '/uploads';

/**
 * 上传文件
 * @param {Number} storeId - 店铺ID
 * @param {File} file - 要上传的文件
 * @param {Function} onProgress - 进度回调函数，用于更新进度条
 * @returns {Promise} - 返回上传结果，包括文件名和URL
 */
export function uploadFile(storeId, file, onProgress = null) {
  const url = `${API_BASE}/${storeId}/files`; // 构建上传URL，如 /v2/api/uploads/123/files
  return restRequest.upload(url, 'file', file, onProgress);
}

/**
 * 删除文件
 * @param {Number} storeId - 店铺ID
 * @param {String} fileUrl - 要删除的文件URL
 * @returns {Promise} - 返回删除结果
 */
export function deleteFile(storeId, fileUrl) {
  const url = `${API_BASE}`; // 删除文件的基础URL，如 /v2/api/uploads
  const params = { storeId, url: fileUrl };
  return restRequest.delete(url, params);
}



// WEBPACK FOOTER //
// ./src/api/upload.js